import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { c as s } from "../../../index-CvSFHqCB.js";
import * as o from "react";
import { c as h } from "../../../utils-BOFVZgHd.js";
import { Label as m } from "../../ui/label.js";
import { RadioGroup as b, RadioGroupItem as w } from "../../ui/radio-group.js";
const N = s("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), R = s(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), V = s("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), $ = o.forwardRef(
  ({ className: c, size: i, label: d, error: e, required: f, field: n, fieldControl: u, id: x, options: v }, p) => {
    const g = o.useId(), a = x || n?.fieldId || g;
    return /* @__PURE__ */ t("div", { className: "w-full flex flex-col gap-1.5", children: [
      d && /* @__PURE__ */ t(m, { htmlFor: a, className: R({ error: !!e }), children: [
        d,
        f && " *"
      ] }),
      /* @__PURE__ */ r(
        b,
        {
          ...u?.field || {},
          ref: p,
          className: h(N({ size: i, className: c })),
          "aria-describedby": e ? `${a}-error` : void 0,
          "aria-invalid": !!e,
          children: v.map((l) => /* @__PURE__ */ t("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ r(w, { value: l.value, id: `${a}-${l.value}` }),
            /* @__PURE__ */ r(m, { htmlFor: `${a}-${l.value}`, children: l.label })
          ] }, l.value))
        }
      ),
      e && /* @__PURE__ */ r("p", { className: V({ size: i }), id: `${a}-error`, children: e })
    ] });
  }
);
$.displayName = "RadioField";
export {
  $ as RadioField,
  N as radioFieldVariants
};
//# sourceMappingURL=index.js.map
